export default "__VITE_ASSET__DYMiAs45__"